<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" class="form-control" v-model="idDelModelo" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de Clínica</option>
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} los tipos de Clínicas</option>
        <option v-for="(tipoDeClinica,index) in tiposDeClinicas" :value="tipoDeClinica.TipoDeClinicaId" :key="index">{{tipoDeClinica.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        tiposDeClinicas: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      this.$store.dispatch("A_SICPO_Catalogos_establecer031TiposClinicasIntranet", parametros);
    },
    methods: {
      cargaTiposClinicasDeIntranet: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;

        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

        axios.post(api.conexion + api.SICPO.catalogos.C031TiposClinicasIntranet, this.parametros, headerPeticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.tiposDeClinicas = respuesta.data.TiposDeClinicas;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        let tipoDeClinicaObj = this.obtenerTipoClinicaObj(evento.target.value);
        this.$store.dispatch("A_SICPO_Catalogos_establecer031TiposClinicasIntranet", parametros);
        this.$emit("valorParaElPadre", evento,tipoDeClinicaObj);
      },
      obtenerTipoClinicaObj: function(clinicaId) {
        let id = parseInt(clinicaId);
        let tipoDeClinica = this.tiposDeClinicas.find(tcBD => tcBD.TipoDeClinicaId == id);
        return tipoDeClinica;
      }
    },
    created() {
      this.cargaTiposClinicasDeIntranet();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SICPO/Catalogos/C031TiposClinicasIntranet.vue